import { Table as MUITable, TableProps } from '@mui/material';

export { type TableProps } from '@mui/material';

export function Table(props: TableProps) {
  return <MUITable {...props} />;
}
